import { z } from "zod";

/// Mirrors shore MeSummaryDto: the caller's own aggregated profile within the
/// active workspace (identity + admin-managed HR fields). Read-only by design.
export const meSummaryManagerSchema = z
  .object({
    displayName: z.string(),
    avatarUrl: z.string().nullable(),
    title: z.string().nullable(),
  })
  .strict();

export const meSummarySchema = z
  .object({
    membershipId: z.string(),
    displayName: z.string(),
    email: z.string(),
    avatarUrl: z.string().nullable(),
    firstName: z.string().nullable(),
    lastName: z.string().nullable(),
    nickName: z.string().nullable(),
    timezone: z.string().nullable(),
    preferredCurrency: z.string().nullable(),
    role: z.enum(["admin", "manager", "member"]),
    title: z.string().nullable(),
    departmentName: z.string().nullable(),
    employmentType: z.enum(["full_time", "part_time", "contractor", "intern"]).nullable(),
    workMode: z.enum(["in_office", "hybrid", "remote"]).nullable(),
    location: z.string().nullable(),
    hireDate: z.string().nullable(),
    employeeId: z.string().nullable(),
    joinedAt: z.string(),
    manager: meSummaryManagerSchema.nullable(),
  })
  .strict();
export type MeSummary = z.infer<typeof meSummarySchema>;
